import { render } from "./AboutEventSection.vue?vue&type=template&id=121fd077&scoped=true"
import script from "./AboutEventSection.vue?vue&type=script&lang=js"
export * from "./AboutEventSection.vue?vue&type=script&lang=js"

import "./AboutEventSection.vue?vue&type=style&index=0&id=121fd077&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-121fd077"]])

export default __exports__